import React from 'react';
import { notification, Modal } from 'antd/lib';
import { graphql, compose, withApollo } from 'react-apollo';
import Loading from '../../common/Loading';
import _ from 'lodash';
import moment from 'moment';

import getAtenciones from '../../../graphql/querys/tramites/getAtenciones.graphql';
import deleteAtencion from '../../../graphql/mutations/tramites/deleteAtencion.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';
import { descargarCSV } from '../funciones/descargarCSV';

import getAtencionesPorRango from '../../../graphql/querys/tramites/getAtencionesPorRango.graphql';

import TablaAtenciones from './TablaAtenciones';
import { errorService } from '../../../graphql/utils/utils';

const confirm = Modal.confirm;

@compose(
  graphql(getUsuario),
  graphql(getAtenciones),
  graphql(deleteAtencion, {
    name: 'deleteAtencion',
    options: {
      refetchQueries: [{ query: getAtenciones }],
    },
  })
)
class VerAtenciones extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      filtro: '',
      currentPage: 1,
      listaTotal: [],
      lista: [],
      primeraCarga: true,
      fechaInicio: null,
      fechaFin: null,
      loadingTabla: false,
    };

    this.onDelete = this.onDelete.bind(this);
    let fechaIni = moment().subtract(7, 'd');
    fechaIni = fechaIni.toDate();

    let fechaFin = moment();
    fechaFin = fechaFin.toDate();

    this.buscarAtencionesPorFecha(fechaIni, fechaFin);
  }

  onDelete(id_atencion) {
    //TODO: Hacer el onDelete.
    // console.log("Se desea eliminar la atencion con id ", id_atencion);

    let { usuario } = this.props;

    if (usuario.rol == 'SUPERVISOR' || usuario.rol == 'FUNCIONARIO') {
      let yo = this;
      confirm({
        title: 'Realmente quiere eliminar esta atencion?',
        content: 'Esta accion no podrá deshacerse',
        onOk() {
          yo.props
            .deleteAtencion({
              variables: { _id: id_atencion },
            })
            .then(res => {
              let id = res.data.deleteCertificacion;

              if (id) {
                yo.eliminarElementoYActualizarLista(id);

                notification.warning({
                  message: 'Certificacion eliminada',
                  description: 'Se ha eliminado la atencion exitosamente',
                });
              }
            })
            .catch(err => {
              console.log('Existio un error a la hora de eliminar la atencion');
              console.log(err);
              errorService(err, {
                _id: id_atencion,
              });
              Modal.error({
                title: 'Error en la eliminacion de la atencion',
                content:
                  'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
              });
            });
        },
        onCancel() {
          // console.log("Cancel");
        },
      });
    } else {
      Modal.error({
        title:
          'Usted no tiene los permisos necesarios para realizar esta operación',
        content:
          'Para poder realizar esta función, debe tener mas permisos en su cuenta de los que tiene ahora mismo. Por favor, en caso de ser necesario, comuníquese con mesa de ayuda del departamento de informática.',
      });
    }
  }

  eliminarElementoYActualizarLista = idElemento => {
    //Esta funcion esta encargada de eliminar el elemento de la lista, actualizar el estado y re-generar la lista.
    let lTotal = [...this.state.listaTotal];

    // eslint-disable-next-line no-unused-vars
    let removidos = _.remove(lTotal, elem => {
      return elem._id == idElemento;
    });
    this.setState(
      {
        ...this.state,
        listaTotal: lTotal,
      },
      function() {
        this.ordenarLista(1, 10);
      }
    );
  };

  filtrarPorNombre = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.

    this.setState({
      ...this.state,
      loadingTabla: true,
    });

    let listaFiltrada = _.filter(this.props.data.getAtenciones, atencion => {
      return atencion.persona
        ? atencion.persona.nombre.toUpperCase().indexOf(filtro.toUpperCase()) >
            -1
        : false;
    });

    this.setState(
      {
        ...this.state,
        loadingTabla: false,
        listaTotal: listaFiltrada,
      },
      function() {
        this.ordenarLista(1, 10);
      }
    );
  };

  filtrarPorApellido = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.

    this.setState({
      ...this.state,
      loadingTabla: true,
    });

    let listaFiltrada = _.filter(this.props.data.getAtenciones, atencion => {
      return atencion.persona
        ? atencion.persona.apellido
            .toUpperCase()
            .indexOf(filtro.toUpperCase()) > -1
        : false;
    });

    this.setState(
      {
        ...this.state,
        loadingTabla: false,
        listaTotal: listaFiltrada,
      },
      function() {
        this.ordenarLista(1, 10);
      }
    );
  };

  filtrarPorDocumento = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.

    this.setState({
      ...this.state,
      loadingTabla: true,
    });

    let listaFiltrada = _.filter(this.props.data.getAtenciones, atencion => {
      return atencion.persona
        ? atencion.persona.num_doc.toUpperCase().indexOf(filtro.toUpperCase()) >
            -1
        : false;
    });

    this.setState(
      {
        ...this.state,
        loadingTabla: false,
        listaTotal: listaFiltrada,
      },
      function() {
        this.ordenarLista(1, 10);
      }
    );
  };

  ordenarLista = (numPagina, tamPagina) => {
    // console.log("Listaaaa");
    // console.log(this.state.listaTotal);
    this.setState({
      loadingTabla: true,
    });
    let listaOrdenada = _.orderBy(
      this.state.listaTotal,
      [
        atencion => {
          // return atencion.persona.apellido.toUpperCase();
          return atencion.fecha;
        },
      ],
      ['desc']
    );

    let listaCorta = _.slice(
      listaOrdenada,
      0 + (numPagina - 1) * tamPagina,
      tamPagina * numPagina
    );

    this.setState({
      ...this.state,
      currentPage: numPagina,
      lista: listaCorta,
      loadingTabla: false,
    });
  };

  // eslint-disable-next-line no-unused-vars
  onChange = (date, dateString) => {
    this.setState(
      {
        ...this.state,
        fechaInicio: date[0]
          .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          .toDate(),
        fechaFin: date[1]
          .set({ hour: 23, minute: 59, second: 59, millisecond: 0 })
          .toDate(),
      },
      () => {
        this.buscarAtencionesPorFecha(
          this.state.fechaInicio,
          this.state.fechaFin
        );
      }
    );
  };

  buscarAtencionesPorFecha = (fechaIni, fechaFin) => {
    this.setState({ loadingTabla: true });
    this.props.client
      .query({
        query: getAtencionesPorRango,
        variables: {
          fechaInicial: fechaIni,
          fechaFinal: fechaFin,
        },
      })
      .then(res => {
        // console.log("RECIBI: ");
        // console.log(res);

        this.setState(
          {
            ...this.state,
            listaTotal: res.data.getAtencionesPorRango,
            primeraCarga: false,
            loadingTabla: false,
          },
          function() {
            this.ordenarLista(1, 10);
          }
        );
      })
      .catch(err => {
        console.log('ERROR EN EL CERTIFICACIONES POR RANGO: ');
        console.log(err);
        errorService(err, {
          fechaInicial: fechaIni,
          fechaFinal: fechaFin,
        });
        Modal.error({
          title: 'Error en la busqueda de certificaciones',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  };

  onDescargar = () => {
    let data = _.map(this.state.listaTotal, atencion => {
      return {
        tipo_doc: atencion.persona ? atencion.persona.tipo_doc : '',
        num_doc: atencion.persona ? atencion.persona.num_doc : '',
        nombre: atencion.persona ? atencion.persona.nombre : '',
        apellido: atencion.persona ? atencion.persona.apellido : '',
        tipo: atencion.tipo_atencion.nombre,
        fecha: moment(atencion.fecha).format('DD/MM/YYYY'),
        usuario: atencion.creador
          ? atencion.creador.apellido.toUpperCase()
          : '-',
      };
    });
    descargarCSV(
      [
        'Tipo Doc',
        'Num Doc',
        'Nombre',
        'Apellido',
        'Tipo de Atencion',
        'Fecha',
        'Usuario',
      ],
      data,
      `ReporteDeAutorizacionesOtros-${moment().format('DD/MM/YYYY-HH:mm')}.csv`
    );
  };

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    const pagination = {
      pageSize: 10,
      current: this.state.currentPage,
      total: this.state.listaTotal ? this.state.listaTotal.length : 0,
      onChange: (page, pageSize) => {
        this.ordenarLista(page, pageSize);
      },
    };

    return (
      <div style={{ marginTop: 30 }}>
        <TablaAtenciones
          atenciones={this.state.lista}
          history={this.props.history}
          onDelete={this.onDelete}
          pagination={pagination}
          filtrarPorNombre={this.filtrarPorNombre}
          filtrarPorApellido={this.filtrarPorApellido}
          filtrarPorDocumento={this.filtrarPorDocumento}
          onChange={this.onChange}
          onDescargar={this.onDescargar}
          fechaInicio={this.state.fechaInicio}
          fechaFin={this.state.fechaFin}
          loadingTabla={this.state.loadingTabla}
        />
      </div>
    );
  }
}

export default withApollo(VerAtenciones);
